import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal, message } from 'antd';
import * as bip39 from 'bip39/src/index';

import Wrapper from './style';
import { addWallet } from '../../common/fetch';

import ConfirmNewWallet from './ConfirmNewWallet';
import InfoWallet from './InfoWallet';
import NamingWallet from './NamingWallet';
import PickAsset from './PickAsset';
import RestoreWallet from './RestoreWallet';
import TestWallet from './TestWallet';
import TypeOfWallet from './TypeOfWallet';

const dummy =
	'unable fashion awful coyote polar dinner uphold almost chase gown pretty east';

class CreateWallet extends Component {
	constructor(prop) {
		super(prop);
		this.state = {
			step: 1,
			seed: dummy.split(' '),
			asset: 'btc'
		};
	}

	componentWillReceiveProps(next) {
		if (next.location.state !== undefined) {
			this.setState({
				asset: next.location.state.currency
			});
		}
	}

	setFinish = async () => {
		const { history } = this.props;
		try {
			this.body.seed = this.seed;
			await addWallet(this.body);
			message.success('Successfully generated Wallet');
			setTimeout(() => {
				history.replace('/wallet');
				this.setState({
					step: 1,
					asset: 'btc',
					seed: dummy.split(' ')
				});
			}, 1000);
		} catch (error) {
			console.error(error);
			message.error(`Fail: ${error.data.message}`);
		}
	};

	restoreSeed = async (words) => {
		const { history } = this.props;
		let seed = '';
		words.forEach((item, index) => {
			if (index === 0) {
				seed += `${item}`;
				return;
			}
			seed += ` ${item}`;
		});
		this.body.seed = seed;
		try {
			await addWallet(this.body);
			message.success('Successfully restored Wallet');
			setTimeout(() => {
				history.replace('/wallet');
				this.setState({
					step: 1,
					asset: 'btc',
					seed: dummy.split(' ')
				});
			}, 1000);
		} catch (error) {
			console.error(error);
			message.error(`Fail: ${error.data.message}`);
		}
	};

	goToTest = () => {
		this.setState({ step: 4 });
	};

	onCancel = () => {
		const { onCancel } = this.props;
		this.setState(
			{
				step: 1,
				seed: dummy.split(' '),
				asset: 'btc'
			},
			onCancel
		);
	};

	onOk = () => {
		const { onOk } = this.props;
		this.setState(
			{
				step: 1,
				seed: dummy.split(' '),
				asset: 'btc'
			},
			onOk
		);
	};

	getnerateSeed = () => {
		this.seed = bip39.generateMnemonic();
		this.setState({ seed: this.seed.split(' '), step: 4 });
	};

	renderBody = () => {
		const { seed, step, asset } = this.state;
		const { onCancel, location } = this.props;
		if (location.state === undefined) return null;

		if (location.state.type === 'new') {
			switch (step) {
				case 1:
					return (
						<PickAsset
							onSubmit={(body) => {
								this.body = body;
								this.setState({ step: 2 });
							}}
							asset={asset}
						/>
					);
				case 2:
					return (
						<TypeOfWallet
							onSubmit={(type) => {
								this.body.type = type;
								this.setState({ step: 3 });
							}}
							onCancel={() => {
								this.setState({ step: 1 });
							}}
						/>
					);
				case 3:
					return (
						<NamingWallet
							onSubmit={(name) => {
								this.body.name = name;
								this.getnerateSeed();
							}}
						/>
					);
				case 4:
					return (
						<ConfirmNewWallet
							onSubmit={() => {
								this.setState({ step: 5 });
							}}
							data={seed}
							onCancel={onCancel}
						/>
					);
				case 5:
					return (
						<TestWallet
							data={seed}
							onSubmit={this.setFinish}
							onCancel={() => {
								this.setState({ step: 3 });
							}}
						/>
					);
				case 6:
					return <InfoWallet onOk={onCancel} />;
				default:
					return null;
			}
		} else {
			switch (step) {
				case 1:
					return (
						<PickAsset
							onSubmit={(body) => {
								this.body = body;
								this.setState({ step: 2 });
							}}
							asset={asset}
						/>
					);
				case 2:
					return (
						<TypeOfWallet
							onSubmit={(type) => {
								this.body.type = type;
								this.setState({ step: 3 });
							}}
							onCancel={() => {
								this.setState({ step: 1 });
							}}
						/>
					);
				case 3:
					return (
						<NamingWallet
							onSubmit={(name) => {
								this.body.name = name;
								this.setState({ step: 4 });
							}}
						/>
					);
				case 4:
					return (
						<RestoreWallet
							onSubmit={this.restoreSeed}
							onCancel={this.onCancel}
						/>
					);
				case 5:
					return <InfoWallet onOk={this.onCancel} />;
				default:
					return null;
			}
		}
	};

	render() {
		const { visible, location } = this.props;
		const { step } = this.state;
		let title = '',
			stepDesc = '';
		if (location.state !== undefined) {
			if (location.state.type === 'new') {
				title = 'Create Wallet';
				stepDesc =
					step === 1
						? '1/5 Pick Asset'
						: step === 2
						? '2/5 Type of Wallet'
						: step === 3
						? '3/5 Name of your wallet'
						: step === 4
						? '4/5 Recovery Phrase'
						: '5/5 Review Words';
			} else {
				title = 'Restore Wallet';
				stepDesc =
					step === 1
						? '1/4 Pick Asset'
						: step === 2
						? '2/4 Type of Wallet'
						: step === 3
						? '3/4 Name of your wallet'
						: '4/4 Enter Recovery Phrase';
			}
		}
		return (
			<Modal
				onCancel={this.onCancel}
				onOk={this.onOk}
				visible={visible}
				title={title}
				footer={null}
			>
				<Wrapper>
					<div className="holla-wallet-wrapper">
						<div className="cw-description">Step {stepDesc}</div>
						{this.renderBody()}
					</div>
				</Wrapper>
			</Modal>
		);
	}
}

export default withRouter(CreateWallet);
